module.exports = "import React from 'react';\nimport DayPicker from 'react-day-picker';\nimport 'react-day-picker/lib/style.css';\n\nexport default function Example() {\n  return (\n    <DayPicker\n      month={new Date(2018, 8)}\n      fromMonth={new Date(2018, 8)}\n      toMonth={new Date(2018, 11)}\n      fixedWeeks\n    />\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/examples/months-restrict.js
// module id = 788
// module chunks = 168707334958949